import { render, staticRenderFns } from "./about-business.vue?vue&type=template&id=3d0e0c1d&"
import script from "./about-business.vue?vue&type=script&lang=js&"
export * from "./about-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports